import React from 'react';
import styled from 'styled-components';
import { Search, Send, Briefcase } from 'lucide-react';

const Container = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #aaaaaa;
  text-align: center;
  margin-bottom: 30px;
  max-width: 600px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  a {
    text-decoration: none;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  padding: 15px 25px;
  border: none;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 1rem;
  font-weight: 600;
  color: #000000;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f0f0f0;
  }

  svg {
    margin-right: 10px;
  }
`;

const Title = styled.h2`
  margin-bottom: 1rem;
  font-size: 2rem;
  color: #000000;
`;

function GetStarted() {
  return (
    <Container>
      <Title>Talk To Counselors. </Title>
      <Subtitle>
        Why figure it out alone? Seek advice from the experts across different verticals to find the best fit for you. Seek digital counseling through Tackoom today!
      </Subtitle>
      <ButtonRow>
        <a href="#category-section">
          <Button>
            <Search size={20} /> Find by Category →
          </Button>
        </a>
        <a href="#get-counselors">
          <Button>
            <Send size={20} /> Go to Counselors →
          </Button>
        </a>

        <a href="#gigs-section">
          <Button>
            <Briefcase size={20} /> Explore for gigs →
          </Button>
        </a>
      </ButtonRow>
    </Container>
  );
}

export default GetStarted;
